__turbopack_context__.v({
  "agingBig": "hguA8a_agingBig",
  "agingCard": "hguA8a_agingCard",
  "agingChip": "hguA8a_agingChip",
  "agingHead": "hguA8a_agingHead",
  "agingLabel": "hguA8a_agingLabel",
  "agingRow": "hguA8a_agingRow",
  "agingRowD": "hguA8a_agingRowD",
  "agingRowK": "hguA8a_agingRowK",
  "agingRowV": "hguA8a_agingRowV",
  "agingRows": "hguA8a_agingRows",
  "agingUnit": "hguA8a_agingUnit",
  "agingValue": "hguA8a_agingValue",
  "arc": "hguA8a_arc",
  "arcLine": "hguA8a_arcLine",
  "body": "hguA8a_body",
  "card": "hguA8a_card",
  "desc": "hguA8a_desc",
  "dim": "hguA8a_dim",
  "eyebrow": "hguA8a_eyebrow",
  "flip": "hguA8a_flip",
  "grid": "hguA8a_grid",
  "head": "hguA8a_head",
  "heading": "hguA8a_heading",
  "holdHint": "hguA8a_holdHint",
  "inner": "hguA8a_inner",
  "media": "hguA8a_media",
  "mediaImg": "hguA8a_mediaImg",
  "mediaImgBlur": "hguA8a_mediaImgBlur",
  "odo": "hguA8a_odo",
  "odoCol": "hguA8a_odoCol",
  "odoStrip": "hguA8a_odoStrip",
  "ringCard": "hguA8a_ringCard",
  "ringHost": "hguA8a_ringHost",
  "section": "hguA8a_section",
  "sig": "hguA8a_sig",
  "sigActive": "hguA8a_sigActive",
  "sigLabel": "hguA8a_sigLabel",
  "sigThumb": "hguA8a_sigThumb",
  "sigThumbBox": "hguA8a_sigThumbBox",
  "soon": "hguA8a_soon",
  "title": "hguA8a_title",
  "widget": "hguA8a_widget",
  "widgetRing": "hguA8a_widgetRing",
});
